"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImageView = void 0;
var React = require("react");
var CartCommonStyle = require("../styles/CartCommon.scss");
function getImageView(imgInfo) {
    return (React.createElement("div", { className: CartCommonStyle.deviceImageContainer },
        React.createElement("div", { className: CartCommonStyle.deviceImg },
            React.createElement("img", { src: imgInfo.imageUrl, alt: imgInfo.imgAltText }))));
}
exports.getImageView = getImageView;
//# sourceMappingURL=CommonHelper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/api/CommonHelper.js
// module id = 2324
// module chunks = 8